import { MobilePhoneLocale } from 'validator/es/lib/isMobilePhone';
import { EN, LANG_LOCAL_STORAGE_KEY, ZH } from '@yaotai/common-utils';

export const MOBILE_PHONE_LOCALE: MobilePhoneLocale[] = ['zh-CN'];

export const HAS_CONFIG_LANG_PAGE = ['activity']; // 支持国际化的页面

export const SPECIFIC_LANG = localStorage.getItem(LANG_LOCAL_STORAGE_KEY)?.includes(EN) ? EN : ZH;
